import 'App.scss';
import React, { useState } from "react";
import styled from 'styled-components';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import img1 from 'assets/images/slides/slide1.jpg';
import img2 from 'assets/images/slides/slide2.jpg';
import img3 from 'assets/images/slides/slide3.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-scroll';
import 'styles/components/main/Slides.scss';


// 반응형 슬라이드
const Img1 = styled.div`
    position: relative;
    width : 100%;
    height: 85vh;
    min-height: calc(20.36vw + 34.3rem);
    background : url(${props => props.src}) center left -15rem / cover no-repeat;
    /* 768 */
    @media screen and (min-width: 768px) {
    height: 90vh;
    min-height: calc(31.25vw + 31rem);
    background : url(${props => props.src}) center center / cover no-repeat;
    }
    /* 1024 */
    @media screen and (min-width: 1024px) {
    height: 95vh;
    min-height: calc(16.83vw + 45.7rem);
    background : url(${props => props.src}) center center / cover no-repeat;
    }
    /* 1440 */
    @media screen and (min-width: 1440px) {
    height: 100vh;
    background : url(${props => props.src}) center center / cover no-repeat;
    }
`;

const Img2 = styled.div`
    position: relative;
    width : 100vw;
    height: 85vh;
    min-height: calc(20.36vw + 34.3rem);
    background : url(${props => props.src}) center left -5rem / cover no-repeat;
    /* 768 */
    @media screen and (min-width: 768px) {
    height: 90vh;
    min-height: calc(31.25vw + 31rem);
    background : url(${props => props.src}) center left / cover no-repeat;
    }
    /* 1024 */
    @media screen and (min-width: 1024px) {
    height: 95vh;
    min-height: calc(16.83vw + 45.7rem);
    background : url(${props => props.src}) center left / cover no-repeat;
    }
    /* 1440 */
    @media screen and (min-width: 1440px) {
    height: 100vh;
    background : url(${props => props.src}) center left / cover no-repeat;
    }
`;

const Img3 = styled.div`
    position: relative;
    width : 100vw;
    height: 85vh;
    min-height: calc(20.36vw + 34.3rem);
    background : url(${props => props.src}) center left -3rem / cover no-repeat;
    /* 768 */
    @media screen and (min-width: 768px) {
    height: 90vh;
    min-height: calc(31.25vw + 31rem);
    background : url(${props => props.src}) center left / cover no-repeat;
    }
    /* 1024 */
    @media screen and (min-width: 1024px) {
    height: 95vh;
    min-height: calc(16.83vw + 45.7rem);
    background : url(${props => props.src}) center left / cover no-repeat;
    }
    /* 1440 */
    @media screen and (min-width: 1440px) {
    height: 100vh;
    background : url(${props => props.src}) center left / cover no-repeat;
    }
`;

// 슬라이드 하단 이전 화살표
const PrevArrow = (props) => {
    const { style, onClick, moreThan768 } = props;

    const pcStyle = {
        ...style, position: 'absolute', bottom: 'calc(3.17vw + 7.57rem)', left: 'calc(2.00vw + 5.25rem)', zIndex: 5, fontSize: 'calc(0.45vw + 1.65rem)', color: 'white'
    }

    const mobileStyle = {
        position: 'absolute', fontSize: 'calc(2.54vw + 1.55rem)', bottom: 'calc(5.09vw + 1.09rem)', zIndex: 5, left: 'calc(12.72vw + -1.77rem)', color: 'white'
    }

    return (
        <div
            className='slick-arrow-prev'
            style={moreThan768 ? pcStyle : mobileStyle}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={faChevronLeft} size={moreThan768 ? '2x' : '1x'} />
        </div >
    );
}

// 슬라이드 하단 다음 화살표
const NextArrow = (props) => {
    const { style, onClick, moreThan768 } = props;

    const pcStyle = {
        ...style, position: 'absolute', bottom: 'calc(3.17vw + 7.57rem)', left: 'calc(2.67vw + 14.9rem)', zIndex: 5, fontSize: 'calc(0.45vw + 1.65rem)', color: 'white'
    }

    const mobileStyle = {
        position: 'absolute', fontSize: 'calc(2.54vw + 1.55rem)', bottom: 'calc(5.09vw + 1.09rem)', zIndex: 5, left: 'calc(20.36vw + .36rem)', color: 'white'
    }

    return (
        <div
            className='slick-arrow-next'
            style={moreThan768 ? pcStyle : mobileStyle}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={faChevronRight} size={moreThan768 ? '2x' : '1x'} />
        </div>
    );
}

const Slides = ({ moreThan768 }) => {

    // 슬라이드 설정

    const pcStyle = {
        position: 'absolute',
        bottom: 'calc(3.62vw + 8.72rem)',
        zIndex: 3,
        // fontSize: '3rem'
    }

    const mobileStyle = {
        position: 'absolute',
        bottom: 'calc(6.36vw + 1.61rem)',
        zIndex: 3,
        // fontSize: '2.5rem'
    }

    const [changedIdx, setChangedIdx] = useState(0);

    const handleAfterChange = (index) => {
        setChangedIdx(index);
    }

    const settings = {
        dots: true, // 개수 표시 점
        appendDots: dots => (
            <div style={moreThan768 ? pcStyle : mobileStyle}>
                <div> {dots} </div>
            </div>
        ),
        infinite: true, // 무한 캐러셀
        speed: 500, // 다음 컨텐츠 까지의 속도
        slidesToShow: 1, // 화면에 보이는 컨텐츠 수
        slidesToScroll: 1, // 스크롤 시 넘어가는 컨텐츠 수
        centerMode: false, // 현재 컨텐츠 가운데 정렬
        centerPadding: '10px', // 중앙 컨텐츠 padding 값
        autoplay: true, // 자동 캐러셀
        autoplaySpeed: 5000, // 자동 캐러셀 속도
        draggable: true, // 드래그      
        fade: true, // 사라졌다 나타나는 효과
        arrows: true, // 좌,우 버튼
        prevArrow: <PrevArrow moreThan768={moreThan768} />,
        nextArrow: <NextArrow moreThan768={moreThan768} />,
        vertical: false, // 세로 캐러셀
        initialSlide: 0, // 첫 컨텐츠 번호
        pauseOnFocus: true, // focus시 정지
        pauseOnHover: false, // hover시 정지
        afterChange: handleAfterChange
    };

    return (
        <div className='Slides'>
            <Slider {...settings}>
                <div className="slide-wrapper">
                    <Img1 src={img1} className='slide'>
                        <div className="slide1">
                            <div className={changedIdx === 0 ? 'text1 effect1' : 'text1'}>
                                <p>어질인소프트는 </p>
                                <p>국방/공공분야의</p>
                                <p>안정적인 시스템 구축과</p>
                                <p>운영을 위한</p>
                                <p>최적의 솔루션을</p>
                                <p>공급하고 있습니다</p>
                            </div>
                        </div>
                    </Img1>
                </div>
                <div className="slide-wrapper">
                    <Img2 src={img2} className='slide'>
                        <div className="slide2">
                            <div className={changedIdx === 1 ? 'text2 effect2' : 'text2'}>
                                <p><span className='fw_normal'>SHARING</span> DREAMS</p>
                                <p className='fw_normal'>AND GROWING</p>
                                <p>TOGETHER</p>
                            </div>
                        </div>
                    </Img2>
                </div>
                <div className="slide-wrapper">
                    <Img3 src={img3} className='slide'>
                        <div className="slide3">
                            <div className={changedIdx === 2 ? 'text3 effect3' : 'text3'}>
                                <p className='fw_normal'>WE</p>
                                <p>CHALLENGE,</p>
                                <p>CREATE,</p>
                                <p>GROW.</p>
                            </div>
                        </div>
                    </Img3>
                </div>
            </Slider >
            <Link to='Intro-wrapper'>
                <button className='downArrowBtn'><FontAwesomeIcon icon={faArrowDown} size='1x' /></button>
            </Link>
        </div >
    );
}

export default React.memo(Slides);
